import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../lib/config';

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit() {
    setError(null);
    if (!email) {
      setError('Please enter your email.');
      return;
    }
    setLoading(true);
    try {
      await fetch(`${API_BASE}/auth/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          redirect_to: `${window.location.origin}/reset-password`,
        }),
      });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  }

  if (sent) {
    return (
      <div style={{ maxWidth: '400px', margin: '80px auto', padding: '24px', textAlign: 'center' }}>
        <h2>Check your email</h2>
        <p>If an account exists for {email}, a reset link has been sent.</p>
        <button onClick={() => navigate('/login')}>Back to login</button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '400px', margin: '80px auto', padding: '24px' }}>
      <h2>Reset your password</h2>
      <p>Enter your email and we'll send you a reset link.</p>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && !loading && handleSubmit()}
        disabled={loading}
        style={{ width: '100%', padding: '10px', marginBottom: '12px' }}
      />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '10px' }}>
        {loading ? 'Sending...' : 'Send reset link'}
      </button>
      <p style={{ marginTop: '16px', textAlign: 'center' }}>
        <span style={{ cursor: 'pointer', color: 'var(--gold)' }} onClick={() => navigate('/login')}>
          Back to login
        </span>
      </p>
    </div>
  );
}

export default ForgotPassword;